import { render, staticRenderFns } from "./dr-property-object-field.vue?vue&type=template&id=b9d3b59e&scoped=true"
import script from "./dr-property-object-field.vue?vue&type=script&lang=js"
export * from "./dr-property-object-field.vue?vue&type=script&lang=js"
import style0 from "./dr-property-object-field.vue?vue&type=style&index=0&id=b9d3b59e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d3b59e",
  null
  
)

export default component.exports